// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Highlights20FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Highlights20Filled: FC<Highlights20FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="m16.98 14.896-2.25-2.25 1.062-1.063 2.25 2.25-1.063 1.063Zm-2.71-9-1.062-1.042 2.25-2.25 1.063 1.063-2.25 2.229Zm-8.54 0-2.25-2.25 1.062-1.063 2.25 2.25-1.063 1.063Zm-2.71 9-1.062-1.063 2.25-2.229 1.063 1.042-2.25 2.25Zm2.042 2.083 1.313-5.542L2 7.708l5.75-.5L10 1.98l2.25 5.25 5.75.48-4.375 3.728 1.313 5.542L10 14.041 5.062 16.98Z" />
        </svg>
    );
};

export default Highlights20Filled;
